import { anonymousUserContext } from '@context/anonymous-user-context';
import type { FirebaseUser } from '@modules/firebase';
import { useContext } from 'react';

/**
 * If the user is authenticated with firebase this will fetch all their details
 */
export default function useAnonymousUser(): FirebaseUser | undefined {
  const { user } = useContext(anonymousUserContext);

  return user;
}
